/**
 * Where „Dokończ sprawdzanie” (views/new-mobile-map/_guided_resume.php,
 * modules/guided-resume.js) stands on the map, and how the keyboard closes
 * it. Up to SHEET_QUERY the list sheet holds the bottom of the screen, so a
 * card over the map would cover the sheet, its tabs and the map controls:
 * there the card opens the list panel, above its heading (`.is-in-sheet`,
 * _start-dialog.scss, compact on a phone held sideways), where the half-open
 * sheet still shows the way back to the step. Wider it stays over the map. It moves again when the width crosses the
 * breakpoint, keeping the focus it holds.
 */
import { DESKTOP_LAYOUT_BREAKPOINT } from '../core/constants';

// The widths at which the list is a bottom sheet (newmobilemap/layout/_sheet.scss).
export var SHEET_QUERY = '(max-width: ' + (DESKTOP_LAYOUT_BREAKPOINT - 1) + 'px)';
var IN_SHEET = 'is-in-sheet';

export function placeGuidedResume(win, doc, root) {
    if (!win || !doc || !root || typeof win.matchMedia !== 'function') return null;
    var panel = doc.getElementById('nm-panel-list');
    var head = panel ? Array.prototype.filter.call(panel.children, function(child) {
        return child.classList.contains('nm-panel-head');
    })[0] : null;
    var home = root.parentNode;
    if (!head || !home) return null;
    var homeNext = root.nextElementSibling;
    var query = win.matchMedia(SHEET_QUERY);
    var inSheet = false;
    var place = function() {
        if (query.matches === inSheet) return;
        inSheet = query.matches;
        var focused = root.contains(doc.activeElement) ? doc.activeElement : null;
        if (inSheet) {
            panel.insertBefore(root, head);
        } else {
            home.insertBefore(root, homeNext && homeNext.parentNode === home ? homeNext : null);
        }
        root.classList.toggle(IN_SHEET, inSheet);
        // A node moved in the document loses the focus; the reader keeps it.
        if (focused && typeof focused.focus === 'function') focused.focus();
    };
    place();
    if (typeof query.addEventListener === 'function') query.addEventListener('change', place);
    else if (typeof query.addListener === 'function') query.addListener(place);
    return query;
}

/** Escape inside the card closes it through its close button, so the same way. */
export function closeGuidedResumeOnEscape(root) {
    if (!root) return;
    root.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape' || root.hidden) return;
        var close = root.querySelector('[data-guided-resume-close]');
        if (!close) return;
        event.preventDefault();
        close.click();
    });
}
